import axios from 'axios';
import { toast } from 'react-toastify';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[2]) : null;
}

// Used for authentication requests. Eg: login, verify, etc.
const authApiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  timeout: 60000,
});

// Used for all other requests. It manages session expiration flow.
const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  timeout: 60000,
});

// function to include the csrf token in the request
function includeCsrfToken(config) {
  const csrfToken = getCookie('csrftoken');
  const method = config.method?.toUpperCase();
  const isSafeMethod = ['GET', 'HEAD', 'OPTIONS'].includes(method || '');
  if (!isSafeMethod && csrfToken) {
    config.headers['X-CSRFToken'] = csrfToken;
  }
  return config;
}

// Add CSRF token to unsafe requests
apiInstance.interceptors.request.use((config) => {
  includeCsrfToken(config);
  return config;
}, (error) => Promise.reject(error));
authApiInstance.interceptors.request.use((config) => {
  includeCsrfToken(config);
  return config;
}, (error) => Promise.reject(error));

// Session expiration handler
apiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Check if the token expired and if we already tried to refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Try to refresh the access_token silently using the authApiInstance
        await authApiInstance.post('/authentication/user/refresh');
        // Resend the original request
        return apiInstance(originalRequest);
      } catch (refreshError) {
        // Failed to refresh, redirect to sign in
        toast.error("Sua sessão expirou. Faça login novamente.", {
          position: "top-right",
          autoClose: 1500,
          onClose: () => goToSignIn(),
        });
        return;
      }
    }

    // If we already tried to refresh or other error
    if (error.response?.status === 401) {
      goToSignIn();
    }

    return Promise.reject(error);
  }
);

function goToSignIn() {
  window.location.href = '/signin';
}

export {
  apiInstance,
  authApiInstance
}